<div class="sales-Orders-responsive p-g-12">
   <div class="p-g-12 p-table-tecfolk-fix">
      <!-- <p-tabView [activeIndex]="tabIndex" (onChange)="handleTabChange($event)">
         <p-tabPanel header="POS" leftIcon="fa fa-check"> -->
      <div class="p-g">
         <div class="p-g-12">
            <p-table [value]="sales" [rowHover]="true" [paginator]="true" [rows]="10" [responsive]="true"
               [loading]="loading" [first]="first" (onPage)="onPageChange($event)">
               <ng-template pTemplate="caption" style="text-align: left">

                  <div class="reportMainFilter">
                     <div class="reportMainFields">
                        <div class="filterFields">
                           <span class="fieldTitle">{{setLabel("searchByInvoiceNumberLabel")}}</span>
                           <input id="searchOrder" #searchOrder autocomplete="off" pinputtext=""
                              (keyup)="searchLocal(saleOrder.invoiceNumber, 'number')"
                              [(ngModel)]="saleOrder.invoiceNumber"
                              [Placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                              class="p-inputtext p-corner-all p-state-default p-widget">
                        </div>
                        <div class="reportMainBtn">
                           <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" [disabled]="loading"
                              (click)="clear()"> <i class="pi pi-times"></i></span>
                        </div>
                     </div>
                     <div class="reportMainBtn">
                        <span [pTooltip]='setLabel("clearSearchTooltipLabel")' tooltipPosition="top" class="iconClear hideOnLaptop"
                           [disabled]="loading" (click)="clear()"> <i class="pi pi-times"></i></span>

                        <!-- <button (click)="clear()"
                           class="clear-Search-Btn p-widget p-state-default p-corner-all p-button-text-only">
                           <i class="fa fa-eraser"></i>&nbsp;Clear Search</button> -->
                        <span [pTooltip]='setLabel("addNewTooltipLabel")' tooltipPosition="top"
                           routerLink="/point-of-sale" class="iconClear " [disabled]="loading"> <i
                              class="pi pi-plus"></i></span>

                        <!-- <button routerLink="/point-of-sale"
                           class="add-New-Btn p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                           <i class="fa fa-plus"></i>&nbsp; New<span> (F2)</span></button> -->
                     </div>
                  </div>
               </ng-template>
               <ng-template pTemplate="header">
                  <tr>
                     <th style="max-width: 90px;">{{setLabel("invoiceNumberLabel")}}</th>
                     <th style="max-width: 90px;">{{setLabel("invoiceDateLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("subTotalLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("discountLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("totalTaxLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("grandTotalLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("cashPaidLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("cashReturnedLabel")}}</th>
                     <!-- <th style="max-width: 130px; text-align: center;">Action</th> -->
                  </tr>
               </ng-template>
               <ng-template pTemplate="body" let-rowData>
                  <tr class="p-selectable-row" (click)="viewSaleOrder(rowData)">
                     <td style="padding-left: 3%;">
                        <div class="mobile-Lable">{{setLabel("invoiceNumberLabel")}}</div>

                        {{rowData.invoiceNumber}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("invoiceDateLabel")}}</div>

                        {{rowData.invoiceDate | date: 'd/M/yy, h:mm a'}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("subTotalLabel")}}</div>

                        {{rowData.subTotal | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("discountLabel")}}</div>

                        {{rowData.discount | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("totalTaxLabel")}}</div>

                        {{rowData.vatTax | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("grandTotalLabel")}}</div>

                        {{rowData.total | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("cashPaidLabel")}}</div>

                        {{rowData.paid | number:'1.0-0'}}
                     </td>
                     <td>
                        <div class="mobile-Lable"> {{setLabel("cashReturnedLabel")}}</div>

                        {{rowData.returned | number:'1.0-0'}}
                     </td>
                     <!-- <td style="text-align: center;">
                              <button pButton type="button" pTooltip="Delete Product" style="margin-right: 5px;"
                                 class="p-button-danger p-button" icon="fa fa-times" (click)="deleteProduct(rowData)">
                              </button>
                              <button pButton type="button" pTooltip="Edit Product Details" icon="fa fa-pencil-square-o"
                                 (click)="viewProduct(rowData)" style="margin-right: 5px;">
                              </button>
                           </td> -->
                  </tr>
               </ng-template>
               <ng-template pTemplate="emptymessage" let-columns>
                  <tr style="color: black;">
                     <td>
                        {{setLabel("noRecordFoundLabel")}}
                     </td>
                  </tr>
               </ng-template>
            </p-table>
         </div>
      </div>
      <!-- </p-tabPanel> -->
      <!-- <p-tabPanel header="Delivery Sale Orders" leftIcon="fa fa-check">
            <div class="p-g">
               <div class="p-g-12">
                  <p-table [value]="deliverySales" [rowHover]="true" [paginator]="true" [rows]="10" [responsive]="true" [loading]="loading" [first]="first" (onPage)="onPageChange($event)">
                     <ng-template pTemplate="caption" style="text-align: left">
                        <input id="searchOrder" #searchOrder style=" color: black ; height:30px ;outline: none; box-shadow: none; margin-right: 8px; width: 18%;"
                           autocomplete="off" pinputtext="" (keyup)="searchLocalDeliveryOrders(saleOrder.invoiceNumber, 'number')"
                           [(ngModel)]="saleOrder.invoiceNumber" placeholder="Search By Invoice Number" type="text" name="name"
                           class="ng-pristine ng-valid ng-touched">
                        <button style="background: #ffffff; color: #0e2031; margin-right: 8px;" (click)="clearSearchDeliveryOrders()"
                           class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                              class="fa fa-eraser"></i>&nbsp;Clear
                           Search
                        </button>
                        <button routerLink="/point-of-sale" style="background-color: #5192d0; margin-right: 8px;"
                           class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                           <i class="fa fa-plus"></i>&nbsp;
                           New
                           <span style="font-family: none;font-size: small;"> (F2)</span>
                        </button>
                     </ng-template>
                     <ng-template pTemplate="header">
                        <tr>
                           <th style="max-width: 90px;">Invoice Number</th>
                           <th style="max-width: 90px;">Invoice Date</th>

                           <th style="max-width: 130px;">Grand-Total</th>
                           <th style="max-width: 130px;">Cash Paid</th>
                           <th style="max-width: 130px;">Cash Returned</th>
                           <th style="max-width: 90px;">Delivery Status</th>
                        </tr>
                     </ng-template>
                     <ng-template pTemplate="body" let-rowData>
                        <tr class="p-selectable-row" (click)="viewSaleOrder(rowData)">
                           <td style="padding-left: 3%;">{{rowData.invoiceNumber}}</td>
                           <td>{{rowData.invoiceDate | date: 'd/M/yy, h:mm a'}}</td>
                           <td>{{rowData.total}}</td>
                           <td>{{rowData.paid}}</td>
                           <td>{{rowData.returned}}</td>
                           <td>
                              {{rowData.status == 'REQUESTED' ? 'Requested'
                              :rowData.status == 'CONFIRMED' ? 'Confirmed'
                              :rowData.status == 'READY_TO_SHIPPED' ? 'Ready to Shipped'
                              :rowData.status == 'SHIPPED' ? 'Shipped'
                              :'Delivered'}}
                           </td>
                        </tr>
                     </ng-template>
                     <ng-template pTemplate="emptymessage" let-columns>
                        <tr style="color: black;">
                           <td>
                              No record found
                           </td>
                        </tr>
                     </ng-template>
                  </p-table>
               </div>
            </div>
         </p-tabPanel> -->
      <!-- </p-tabView> -->
   </div>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-spin-clockwise" [fullScreen]="true">
   <p style="color: white">{{setLabel("pleaseWaitLabel")}}</p>
</ngx-spinner>